class LslBeforeAfter extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.lsl-ba__track');
    this.before = this.querySelector('.lsl-ba__layer--before');
    this.handle = this.querySelector('.lsl-ba__handle');
    this.range = this.querySelector('.lsl-ba__range');
    this.knob = this.querySelector('.lsl-ba__knob');

    if (!this.track || !this.before || !this.handle || !this.range) return;

    this.dragging = false;
    this.position = Number(this.dataset.position || this.range.value || 50);
    this.setPosition(this.position);

    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onPointerUp = this.onPointerUp.bind(this);
    this.onRangeInput = this.onRangeInput.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);

    this.track.addEventListener('pointerdown', this.onPointerDown);
    window.addEventListener('pointermove', this.onPointerMove);
    window.addEventListener('pointerup', this.onPointerUp);
    window.addEventListener('pointercancel', this.onPointerUp);
    this.range.addEventListener('input', this.onRangeInput);
    if (this.knob) this.knob.addEventListener('keydown', this.onKeyDown);
  }

  disconnectedCallback() {
    this.track?.removeEventListener('pointerdown', this.onPointerDown);
    window.removeEventListener('pointermove', this.onPointerMove);
    window.removeEventListener('pointerup', this.onPointerUp);
    window.removeEventListener('pointercancel', this.onPointerUp);
    this.range?.removeEventListener('input', this.onRangeInput);
    this.knob?.removeEventListener('keydown', this.onKeyDown);
  }

  setPosition(value) {
    const clamped = Math.max(0, Math.min(100, Number(value)));
    this.position = clamped;
    this.style.setProperty('--ba-pos', `${clamped}%`);
    this.before.style.clipPath = `inset(0 ${100 - clamped}% 0 0)`;
    this.handle.style.left = `${clamped}%`;
    if (this.range && Number(this.range.value) !== clamped) {
      this.range.value = String(Math.round(clamped));
    }
  }

  positionFromEvent(event) {
    const rect = this.track.getBoundingClientRect();
    if (!rect.width) return this.position;
    const x = event.clientX - rect.left;
    return (x / rect.width) * 100;
  }

  onPointerDown(event) {
    if (event.button != null && event.button !== 0) return;
    this.dragging = true;
    this.track.setPointerCapture?.(event.pointerId);
    this.classList.add('is-dragging');
    this.setPosition(this.positionFromEvent(event));
    event.preventDefault();
  }

  onPointerMove(event) {
    if (!this.dragging) return;
    this.setPosition(this.positionFromEvent(event));
  }

  onPointerUp() {
    if (!this.dragging) return;
    this.dragging = false;
    this.classList.remove('is-dragging');
  }

  onRangeInput(event) {
    this.setPosition(event.target.value);
  }

  onKeyDown(event) {
    const step = event.shiftKey ? 10 : 2;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowDown') {
      event.preventDefault();
      this.setPosition(this.position - step);
    } else if (event.key === 'ArrowRight' || event.key === 'ArrowUp') {
      event.preventDefault();
      this.setPosition(this.position + step);
    } else if (event.key === 'Home') {
      event.preventDefault();
      this.setPosition(0);
    } else if (event.key === 'End') {
      event.preventDefault();
      this.setPosition(100);
    }
  }
}

customElements.define('lsl-before-after', LslBeforeAfter);
